
function* confirmUserPassword (action, state) {
};

export default confirmUserPassword;